import { z } from 'zod';
import { MarketplaceProjectsFiltersValidator } from '../collators/schema';

const CustomPageParameterZod = z
  .object({
    name: z.string().trim().min(1),
    valuePath: z.string().trim().min(1),
  })
  .strict();

const CustomPageZod = z
  .object({
    title: z.string().trim().min(1),
    url: z.string().trim().url(),
    route: z.string().trim().min(1).regex(/^\//),
    identifier: z
      .string()
      .trim()
      .min(1)
      .regex(/^[a-zA-Z0-9_-]*$/),
    mountFunction: z.string().trim().min(1),
    unmountFunction: z.string().trim().min(1),
    parameters: z.array(CustomPageParameterZod),
  })
  .strict();

const CustomProjectPageConditions = z
  .object({
    useCaseTemplateIds: z.array(z.string().trim().min(1)).optional(),
    types: z.array(z.string().trim().min(1)).optional(),
  })
  .strict();

const ExtendedCustomPage = CustomPageZod.extend({
  conditions: CustomProjectPageConditions.optional(),
}).strict();

export const ConfigValidator = z.object({
  fe: z.object({
    displayNameDescriptorField: z.object({
      default: z.string(),
      types: z.record(z.string()).optional(),
    }),
    customPages: z
      .object({
        page: z.array(CustomPageZod).optional(),
        projectPage: z.array(ExtendedCustomPage).optional(),
        consumableInterfacePage: z.array(ExtendedCustomPage).optional(),
      })
      .strict()
      .optional(),
  }),
  search: z.object({
    'marketplace-projects': z.object({
      filters: MarketplaceProjectsFiltersValidator,
    }),
  }),
});

export type ConfigSchema = z.infer<typeof ConfigValidator>;

export const defaultConfig: DeepPartial<ConfigSchema> = {
  fe: {
    displayNameDescriptorField: {
      default: 'name',
    },
  },
};

type DeepPartial<T> = {
  [P in keyof T]?: T[P] extends object ? DeepPartial<T[P]> : T[P];
};
